import React, { Fragment } from "react";

import Base          from "~/components/paginator";
import GameRecordCard from "../Cards/GameRecord";
import User          from '~/services/user';


const GamesRecordsPaginator = ()=> {

  return (
    <Fragment>
      <h5> Games Records </h5>
      <Base classItem="wallet-item" endpoint={User.paginator.gamesRecords} card={GameRecordCard} />
    </Fragment>
  );
}

export default GamesRecordsPaginator;
